module.exports = __webpack_public_path__ + "static/media/how-esg-is--slowly-making-indian-businesses-future-ready.0a480d61.webp";